
<div class="light-scroll" style="max-height: 500px; ">
  @for (feature of features; track feature) {
    <dl>
      <dt><mibp-resource-string [key]="'feature_' + feature + '_name'"></mibp-resource-string></dt>
      <dd><mibp-resource-string [isHtml]="true" [key]="'feature_' + feature + '_description'"></mibp-resource-string></dd>
    </dl>
  }


  <!-- <mibp-horizontal-scroll-container>
  <table class="my-table mt-4 mb-4">
    <thead>
      <tr>
        <th>Feature Identifier</th>
        <th>Feature Name</th>
        <th>Feature Description</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let feature of features">
        <td><code>{{feature}}</code></td>
        <td><strong><mibp-resource-string [key]="'feature_' + feature + '_name'"></mibp-resource-string></strong></td>
        <td>
          <div class="my-body">
            <mibp-resource-string [isHtml]="true" [key]="'feature_' + feature + '_description'"></mibp-resource-string>
          </div>
        </td>

      </tr>
    </tbody>
  </table>
</mibp-horizontal-scroll-container> -->

</div>
